<div class="verificar-autenticidade-container">
  <div class="header-section">
    <h1 class="title">Verificação de Autenticidade de Declarações</h1>
    <p class="description">
      Selecione o módulo (PAD ou TAC), informe o código de autenticidade da declaração
      (formato XXXX-XXXX-XXXX-XXXX, no rodapé do documento) e clique em Verificar.
    </p>
  </div>

  <div class="form-section" [formGroup]="verificacaoForm">
    <mat-form-field appearance="outline" class="modulo-field">
      <mat-label>Módulo</mat-label>
      <mat-select formControlName="modulo" (selectionChange)="onModuloChange()">
        <mat-option value="pad">PAD</mat-option>
        <mat-option value="tac">TAC</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="input-container">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Código de Autenticidade</mat-label>
        <input
          matInput
          type="text"
          formControlName="codigo"
          placeholder="XXXX-XXXX-XXXX-XXXX"
          (input)="formatarCodigo($event)"
          autocomplete="off"
        >
        <mat-error *ngIf="verificacaoForm.get('codigo').invalid">
          Digite um código válido no formato XXXX-XXXX-XXXX-XXXX
        </mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        (click)="verificarAutenticidade()"
        [disabled]="verificacaoForm.invalid || verificandoLoading"
        class="verificar-btn"
      >
        <mat-icon>verified</mat-icon>
        Verificar
      </button>
    </div>
  </div>

  <div class="loading-indicator" *ngIf="verificandoLoading">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    <p>Verificando autenticidade...</p>
  </div>

  <div class="resultado-section" *ngIf="resultadoVisible && !verificandoLoading">
    <div class="resultado-card" [ngClass]="{'valido': declaracaoValida, 'invalido': !declaracaoValida}">
      <div class="card-header">
        <mat-icon *ngIf="declaracaoValida" class="icon-valido">check_circle</mat-icon>
        <mat-icon *ngIf="!declaracaoValida" class="icon-invalido">cancel</mat-icon>
        <h2 class="card-title">
          {{ declaracaoValida ? 'Declaração Autêntica' : 'Declaração Inválida' }}
        </h2>
      </div>

      <div class="card-content" *ngIf="declaracaoValida && detalhesVerificacao">
        <div class="detalhes-item">
          <span class="detalhe-label">Módulo:</span>
          <span class="detalhe-valor">{{ modulo | uppercase }}</span>
        </div>
        <div class="detalhes-item">
          <span class="detalhe-label">Tipo de Declaração:</span>
          <span class="detalhe-valor">{{ tipoDeclaracaoLabel }}</span>
        </div>
        <div class="detalhes-item" *ngIf="declaracaoInfo?.data_emissao">
          <span class="detalhe-label">Data de Emissão:</span>
          <span class="detalhe-valor">{{ declaracaoInfo.data_emissao | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="detalhes-item" *ngIf="detalhesVerificacao.servidor">
          <span class="detalhe-label">CPF do Servidor:</span>
          <span class="detalhe-valor">{{ formatarCpf(detalhesVerificacao.servidor.cpf) }}</span>
        </div>
        <div class="detalhes-item" *ngIf="detalhesVerificacao.servidor">
          <span class="detalhe-label">Nome do Servidor:</span>
          <span class="detalhe-valor">{{ detalhesVerificacao.servidor.nome }}</span>
        </div>
        <div class="detalhes-item" *ngIf="codigoExibido">
          <span class="detalhe-label">Código:</span>
          <span class="detalhe-valor">{{ codigoExibido }}</span>
        </div>

        <div class="actions">
          <button
            mat-raised-button
            color="primary"
            (click)="downloadDeclaracao()"
            [disabled]="downloadLoading"
            class="download-btn"
          >
            <mat-icon>download</mat-icon>
            Download do comprovante
          </button>
          <mat-spinner *ngIf="downloadLoading" diameter="20" class="download-spinner"></mat-spinner>
        </div>
      </div>

      <div class="card-content invalido-content" *ngIf="!declaracaoValida">
        <p class="mensagem-invalido">
          O código informado não corresponde a uma declaração válida de {{ modulo | uppercase }} no sistema.
        </p>
        <p class="orientacao-invalido">
          Verifique se o módulo e o código foram informados corretamente.
        </p>
        <div class="actions">
          <button mat-raised-button (click)="limparFormulario()" class="tentar-novamente-btn">
            <mat-icon>refresh</mat-icon>
            Tentar Novamente
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
